import React from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';
import { loadReCaptcha } from 'react-recaptcha-v3';

import { withMainControls } from '@eb/eds-structure';

import { TYPE_ERROR } from '@eb/eds-notification';
import { AlertChunky } from '@eb/eds-iconography';

import {
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
} from '@eb/social-login-facebook';

import LinkAppleAccountSvg from '../../components/illustrations/LinkAppleAccount';
import LinkFacebookAccountSvg from '../../components/illustrations/LinkFacebookAccount';
import LinkGoogleAccountSvg from '../../components/illustrations/LinkGoogleAccount';

import PageHeader from '../../components/PageHeader';
import LinkAccountsLogInForm from '../../components/forms/LinkAccountsLogInForm';
import SplitContainer from '../../connectedComponents/SplitContainer';

/**
 * We currently do not have a test nor a way to access this page.
 * It seems that the redirection occurs after an unknown error
 * from the social provider but using data like the email and
 * checking the user in the database as existent.
 */
/**
 * List of urls that will lead to this page:
 * * BASE_URL/LINK_ACCOUNTS_LOG_IN_PATH
 */
class LinkAccountsLoginPage extends React.PureComponent {
    static propTypes = {
        onLinkAccountsOnLogin: PropTypes.func,
        onForceStld: PropTypes.func,
        email: PropTypes.string,
        handleClickViewPassword: PropTypes.func,
        moveBack: PropTypes.func,
        clearAuthNotification: PropTypes.func,
        recaptcha2PublicKey: PropTypes.string,
        recaptcha3PublicKey: PropTypes.string,
        disableRecaptcha3: PropTypes.bool,
        showCaptcha: PropTypes.bool,
        usesNewStyles: PropTypes.bool,
        linkedAccountSuccessUrl: PropTypes.string,
    };

    componentDidMount() {
        if (!this.props.disableRecaptcha3) {
            loadReCaptcha(this.props.recaptcha3PublicKey);
        }
    }

    _handleSubmit = (formData) => {
        const { clearAuthNotification, onLinkAccountsOnLogin } = this.props;

        // clear notification everytime form is submitted
        if (clearAuthNotification) {
            clearAuthNotification();
        }

        return onLinkAccountsOnLogin(formData);
    };

    _handleShowNotification = (error) => {
        const { addMainNotification } = this.props;

        /*Limit the call to addMainNotification to only if
        a notification hasn't been shown since last submit.*/
        if (!this._hasNotification) {
            addMainNotification({
                type: TYPE_ERROR,
                children: error,
                iconType: <AlertChunky />,
            });

            this._hasNotification = true;
        }
    };

    _handleClearNotification = () => {
        const { hideMainNotification } = this.props;

        this._hasNotification = false;
        hideMainNotification && hideMainNotification();
    };

    render() {
        const {
            handleClickViewPassword,
            recaptcha2PublicKey,
            recaptcha3PublicKey,
            showCaptcha,
            email,
            moveBack,
            linkedAccountSuccessUrl,
            disableRecaptcha3,
            onForceStld,
            clearAuthNotification,
            socialProvider,
            handleSendMailLinkAccount,
            usesNewStyles,
        } = this.props;

        const pageHeaderProps = {
            headerText: gettext('Link accounts'),
            iconType: <LinkFacebookAccountSvg />,
            shouldNotModifyIcon: true,
        };

        if (socialProvider === SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE) {
            pageHeaderProps.iconType = <LinkAppleAccountSvg />;
        } else if (
            socialProvider === SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE
        ) {
            pageHeaderProps.iconType = <LinkGoogleAccountSvg />;
        }

        const buttonCTA = gettext('Link your accounts');

        return (
            <SplitContainer
                shouldShowSecondaryPanel={usesNewStyles}
                usesNewStyles={usesNewStyles}
                header={<PageHeader {...pageHeaderProps} />}
            >
                <LinkAccountsLogInForm
                    buttonCTA={buttonCTA}
                    onSubmit={this._handleSubmit}
                    onForceStld={onForceStld}
                    clearAuthNotification={clearAuthNotification}
                    handleEmailEdit={moveBack}
                    handleClickViewPassword={handleClickViewPassword}
                    recaptcha2PublicKey={recaptcha2PublicKey}
                    recaptcha3PublicKey={recaptcha3PublicKey}
                    disableRecaptcha3={disableRecaptcha3}
                    showCaptcha={showCaptcha}
                    email={email}
                    showNotification={this._handleShowNotification}
                    clearNotification={this._handleClearNotification}
                    linkedAccountSuccessUrl={linkedAccountSuccessUrl}
                    handleSendMailLinkAccount={handleSendMailLinkAccount}
                />
            </SplitContainer>
        );
    }
}

export default withMainControls(LinkAccountsLoginPage);
